export const SET_USER = "SET_USER"
export const LOGOUT = "LOGOUT"
export const CHANGE_LANG = "CHANGE_LANG"
export const SET_UPDATE_PROFILE = 'SET_UPDATE_PROFILE';



